import { utils } from '../../utils/index.js';
import { type WebviewJavascriptBridgeApi } from '../type.api.js';
import { call } from './call.js';
import { type IOSSendWebCallbackDataToNtv } from './types.ios.js';

const { log } = utils;

/**
 * 通知Native, Web端已经准备就绪, 如果Native有队列通知
 * 这个时候可以发送调用客户端了, 通常情况可以考虑有Native主动调用WEBregister的接口方法时候有用.
 */
export const ntvInit = (): void => {
  if (!window['Fabric_Ios_Init']) {
    log.logData('通知[iOS]当前bridge已经ready...');

    window['Fabric_Ios_Init'] = true;
    // notify native that js apis register successfully on next event loop
    setTimeout(() => {
      call('_dsb.dsinit');
    }, 0);
  }
};

/**
 * 当前fabric是否已经ready初始化成功
 * @returns
 */
export const isFullyInitialized = () => {
  return window['Fabric_Ios_Init'] || false;
};

/**
 * 当Native主动调用Web的时候,Web端处理完, 回调给结果数据到Native的通道
 */
export const webCallbackToNtv = (callbackData: IOSSendWebCallbackDataToNtv) => {
  log.logData('[iOS] webCallbackToNtv()', 'callbackData:', callbackData);

  call('_dsb.returnValue', callbackData);
};

/**
 * Native内置接口, 判断指定调用的接口是否存在.
 * @param name 接口名称
 * @param type 接口类型 `all`, `sync` |`async`
 */
export const ntvHasMethod: WebviewJavascriptBridgeApi['ntvHasMethod'] = (
  name: string,
  type: 'all' | 'sync' | 'async' = 'all'
): boolean => {
  const result = call<
    '_dsb.hasNativeMethod',
    { name: string; type: string },
    boolean
  >('_dsb.hasNativeMethod', {
    name,
    type: type === 'sync' ? 'syn' : type === 'async' ? 'asyn' : 'all',
  });
  return result.data === true;
};
/**
 * @example
 * ```ts
 * //disable
 *  ntvDisableJavascriptDialogBlock()
 * //enable
 *  ntvDisableJavascriptDialogBlock(false)
 * ```
 * @param disable 是否禁用 `true`
 */
export const ntvDisableJavascriptDialogBlock = (disable?: boolean): void => {
  call('_dsb.disableJavascriptDialogBlock', {
    disable: disable !== false,
  });
};
